import { useTranslation } from '../../shared/i18n';
import React, { useState } from 'react';
import { Modal, Form, message } from 'antd';
import registrarService from '../services/registrarService';
import ContactFields, { fieldErrorsToForm, fromFormContact } from '../pages/domain-registration/components/ContactFields';

/**
 * 快速新建通讯录联系人（购物车结算内联用）。
 * onCreated(contact) —— 返回新建的联系人（含 id）
 */
const QuickContactModal = ({ open, onCancel, onCreated, isFirst = false }) => {
    const { t, i18n } = useTranslation();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);

    const handleOk = async () => {
        let values;
        try {
            values = await form.validateFields();
        } catch (e) {
            return;
        }
        const c = fromFormContact(values);
        const payload = {
            ...c,
            template_name: (c.kind === 'organization' && c.company) || `${c.first_name} ${c.last_name}`.trim(),
            is_default: isFirst,
        };
        setSaving(true);
        try {
            const res = await registrarService.createContactTemplate(payload);
            if (res?.success && res.data?.id) {
                message.success(t('Contact created'));
                form.resetFields();
                onCreated && onCreated(res.data);
            } else {
                message.error(res?.error || t('Creation failed'));
            }
        } catch (err) {
            const fe = fieldErrorsToForm(err?.field_errors, () => [], { t, lang: i18n?.language, form });
            if (fe.length) form.setFields(fe);
            message.error(err?.error || err?.message || t('Creation failed'));
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            title={t('Create contact')}
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            confirmLoading={saving}
            okText={t('Create and use')}
            width={560}
            forceRender
        >
            <Form form={form} layout="vertical" requiredMark={false}>
                <ContactFields compact />
            </Form>
        </Modal>
    );
};

export default QuickContactModal;
